import { ContentSwitcher } from "libs/design-system/src/components/ContentSwitchers/ContentSwitcher";

import type { ITabInfoCard } from "@app/dashboard/types/innerLayout/cards/tabs-info-card";
import { InfoCard } from "../InfoCard";
import styles from "./tabs-info-card.module.scss";


export const TabsInfoCard = (props: ITabInfoCard) => {

  const { tabs, width, alignment, ...infoCardProps } = props;
  const hasTabs = !!tabs?.length;

  return (
    <div
      className={styles["tabs-info-card"]}
      style={width ? { width } : undefined}
    >

      <div className={styles["tabs-info-card__title"]}>
        {infoCardProps.title}
      </div>

      {
        hasTabs && (
          <div className={styles["tabs-info-card__tabs"]}>
            <ContentSwitcher
              alignment={alignment}
              tabsProps={tabs}
            />
          </div>
        )
      }

      <InfoCard
        {...infoCardProps}
        title=""
        width="100%"
      />
    </div>
  )
}
